import { FC, useEffect, useState } from 'react';
import { LandscapeIndicatorTargetTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { fetchVerificationStatuses } from '../../../store/landscapeAPI/verificationStatus/reducers/verification-status.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import {} from '../../../store/landscapeAPI/value/reducers/contribution.slice';
import { ValueResponseDto } from '../../../store/landscapeAPI/value/dto/response/value-response.dto';
import { ValueSaveRequestDto } from '../../../store/landscapeAPI/value/dto/request/value-save-request.dto';
import { useParams } from 'react-router-dom';
import { ValueType } from '../../../store/landscapeAPI/value/value-type';
import { DEFAULT_VERIFICATION_STATUS_ID, getUUID } from '../../../utils/UUID';
import { fetchLandscapeIndicatorDetailsById } from '../../../store/landscapeAPI/landscape/reducers/landscape-indicator.slice';
import { ValueUpdateRequestDto } from '../../../store/landscapeAPI/value/dto/request/value-update-request.dto';
import {
  saveTarget,
  updateTarget,
} from '../../../store/landscapeAPI/value/reducers/target.slice';

interface LandscapeIndicatorTargetPageProps {}

const LandscapeIndicatorTargetPage: FC<
  LandscapeIndicatorTargetPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id, landscapeIndicatorId } = useParams();

  const [loading, setLoading] = useState<boolean>(true);
  const [target, setTarget] = useState<ValueResponseDto>({
    date: '',
    qty: null,
    qtyUnit: null,
    time: null,
    timeUnit: null,
    compactIndicatorId: landscapeIndicatorId!,
    valuesType: ValueType.Target,
    verificationStatusId: '',
    verificationStatus: null,
    id: '',
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
  });

  const { verificationStatuses, status } = useSelector(
    (state: RootState) => state.verificationStatusSlice
  );

  useEffect(() => {
    if (!landscapeIndicatorId) {
      return;
    }
    dispatch(fetchLandscapeIndicatorDetailsById(landscapeIndicatorId))
      .unwrap()
      .then((resp) => {
        if (resp.target.length > 0) {
          setTarget(resp.target[0]);
        }
        setLoading(false);
      });
  }, [landscapeIndicatorId, dispatch]);

  useEffect(() => {
    dispatch(fetchVerificationStatuses());
  }, [dispatch]);

  const handleOnChange = (target: ValueResponseDto) => {
    setTarget(target);
  };

  const callbackFn = async (target: ValueResponseDto) => {
    if (target.id !== '') {
      const targetToUpdate: ValueUpdateRequestDto = {
        indicatorId: '',
        qty: target.qty,
        qtyUnit: target.qtyUnit,
        time: target.time,
        timeUnit: target.timeUnit,
        compactId: id!,
        date: target.date,
        compactIndicatorId: landscapeIndicatorId!,
        verificationStatusId:
          target.verificationStatusId || DEFAULT_VERIFICATION_STATUS_ID,
        id: target.id,
        published: target.published,
      };
      await dispatch(updateTarget(targetToUpdate));
    } else {
      const targetToSave: ValueSaveRequestDto = {
        indicatorId: '',
        qty: target.qty,
        qtyUnit: target.qtyUnit,
        time: target.time,
        timeUnit: target.timeUnit,
        compactId: id!,
        date: target.date,
        compactIndicatorId: landscapeIndicatorId!,
        verificationStatusId:
          target.verificationStatusId || DEFAULT_VERIFICATION_STATUS_ID,
        id: getUUID(),
        published: target.published,
      };
      await dispatch(saveTarget(targetToSave));
    }
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {!loading && (
        <LandscapeIndicatorTargetTemplate
          verificationStatuses={verificationStatuses ?? []}
          target={target}
          handleOnChange={handleOnChange}
          callbackFn={callbackFn}
        />
      )}
    </>
  );
};

export default LandscapeIndicatorTargetPage;
